import React, { useState, useEffect } from 'react'
import useStyles from './styles'
import { Paper, Typography, Button, TextField } from '@material-ui/core'
import FileBase from 'react-file-base64'
import { useDispatch, useSelector } from 'react-redux'
import { createPost, updatePost } from '../../actions/posts'

const Form = ({ currentId, setCurrentId }) => {
    const classes = useStyles()
    const dispatch = useDispatch()
    const post  = useSelector((state) => currentId ? state.posts.posts.find((p) => p._id === currentId): null)
    const [postData, setPostData] = useState({
        title: '',
        message: '',
        tags: '',
        selectedFile: ''
    })
    const user = JSON.parse(localStorage.getItem('profile'))

    useEffect(() => {
        if(post !== null){
            setPostData(post)
            console.log(postData)
        } 
    },[post])

    const clear = () => {
        console.log('Clear clicked')
        setCurrentId(null)
        setPostData({
            title: '',
            message: '',
            tags: '',
            selectedFile: '',
        })
    }

    const handleSubmit = (e) => {
        e.preventDefault()

        if(currentId){
            dispatch(updatePost(currentId, { ...postData, name: user?.result?.name }))
        }else{
            dispatch(createPost({ ...postData, name: user?.result?.name }))
        }
        clear()
    }

    if(!user?.result?.name){
        return(
            <Paper className={classes.paper}>
                <Typography variant='h6' align='center'>
                    Please Sign in to create your own Posts
                </Typography>
            </Paper>
        )
    } 

    return (
        <Paper className={classes.paper}>
            <form
                autoComplete='off'
                noValidate
                className={`${classes.root} ${classes.form}`}
                onSubmit={handleSubmit}
            >
                <Typography variant='h6'> {currentId ? 'Editing' : 'Creating'} a Memory </Typography>
            
                <TextField 
                    variant='outlined'
                    label='Title' 
                    name='title' 
                    fullWidth
                    value={postData.title}
                    onChange={(e) => setPostData({...postData , title: e.target.value})}
                />
                <TextField 
                    variant='outlined'
                    label='Message' 
                    name='message' 
                    fullWidth
                    value={postData.message}
                    onChange={(e) => setPostData({...postData , message: e.target.value})}
                />
                <TextField 
                    variant='outlined'
                    label='Tags' 
                    name='tags' 
                    fullWidth
                    value={postData.tags}
                    onChange={(e) => setPostData({...postData , tags: e.target.value.split(',')})}
                />
                <div className={classes.fileInput}>
                    <FileBase
                        type='file'
                        multiple={false}
                        onDone={({ base64 }) => setPostData({...postData, selectedFile: base64})}
                    />
                </div>
                <Button 
                    className={classes.buttonSubmit} 
                    variant='contained' 
                    color='primary' 
                    size='large'
                    type='submit'
                    fullWidth
                >
                    Submit
                </Button>

                <Button 
                    variant='contained' 
                    color='secondary' 
                    size='large'
                    fullWidth
                    onClick={clear}
                >
                    Clear
                </Button>

            </form>
        </Paper>
    )
}

export default Form
